import React from 'react';

import BaseSelect from '$partials/fields/select.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/filters/individual.d.ts').Select}
 */
export const Select = (props) => {
    return (
        <fieldset className='flex w-full justify-between gap-16 h-[44px] items-center'>
            <legend className='sr-only'>{props.label}</legend>
            <div
                aria-hidden={true}
                className='type-style-eyebrow'>
                {props.label}
            </div>
            <div>
                <BaseSelect {...props} />
            </div>
        </fieldset>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default Select;
